import React, { useContext } from "react";
import AuthContext from "../../../contexts/auth";
import Swal from "sweetalert2";
import "./index.css";
import { FaUser, FaEye, FaEyeSlash } from "react-icons/fa";

const UserProfile = () => {
  const { user, updatePwdClient  } = useContext(AuthContext);



  const handleErrorResponse = (response) => {
    switch (response.message) {
      case "OLD_PASSWORD_INCORRECT":
        return "La contraseña actual es incorrecta";
      case "OLD_PASSWORD_SAME_AS_NEW":
        return "La nueva contraseña no puede ser igual a la anterior";
      case "ERROR_PASSWORD_UPDATE":
        return "No se pudo actualizar la contraseña, intente nuevamente";
      default:
        return "Hubo un error al actualizar la contraseña, intente nuevamente";
    }
  };
  
  const handleUpdatePassword = async () => {
    Swal.fire({
      icon: "info",
      title: "Actualizar Contraseña",
      html: `
 <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%;">
    <div style="position: relative;">
      <input id="current-password" type="password" class="swal2-input" placeholder="Contraseña Actual" style="flex: 1; height: 45px; padding-right: 10px;">
    </div>
    <div style="position: relative;">
      <input id="new-password" type="password" class="swal2-input" placeholder="Nueva Contraseña" style="flex: 1; height: 45px; padding-right: 10px;">
    </div>
    <div style="position: relative;">
      <input id="confirm-password" type="password" class="swal2-input" placeholder="Confirmar Nueva Contraseña" style="flex: 1; height: 45px; padding-right: 10px;">
    </div>
    <hr style="width: 100%; border: 0px solid #ccc; opacity: 0.0; margin: 10px 0;">
 
    <button type="button" id="toggle-password-visibility" class="toggle-password" 
        onclick="togglePasswordVisibility()" 
        style="background: black; border: none; display: flex; align-items: center; justify-content: center; padding: 0; cursor: pointer; width: fit-content; height: fit-content;">
      <span id="toggle-password-text" 
          style="background-color: #0F4372; color: white; padding: 10px 20px; border: none; border-radius: 5px; font-size: 0.9rem; transition: background-color 0.3s; display: flex; align-items: center; justify-content: center;">
        Mostrar Contraseñas
      </span>
    </button>
</div>

    `,
      showCancelButton: true,
      confirmButtonText: `Actualizar 
    `,
      cancelButtonText: "Cancelar",
      customClass: {
      confirmButton: 'custom-confirm-button',
      cancelButton: 'custom-cancel-button',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
     },
      preConfirm: () => {
        const currentPassword = Swal.getPopup().querySelector("#current-password").value.trim();
        const newPassword = Swal.getPopup().querySelector("#new-password").value.trim();
        const confirmPassword = Swal.getPopup().querySelector("#confirm-password").value.trim();
        const passwordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,12}$/;
  
        if (!currentPassword || !newPassword || !confirmPassword) {
          Swal.showValidationMessage("Todos los campos son obligatorios");
          return false;
        }
        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage("Las contraseñas no coinciden");
          return false;
        }
        if (currentPassword === newPassword || currentPassword === confirmPassword) {
          Swal.showValidationMessage("La nueva contraseña no puede ser igual a la actual");
          return false;
        }
       if (!passwordRegex.test(newPassword)) {
            const errors = [];
            if (newPassword.length < 8 || newPassword.length > 12) {
              errors.push("La contraseña debe tener entre 8 y 12 caracteres.");
            }
            if (!/[0-9]/.test(newPassword)) {
              errors.push("La contraseña debe contener al menos un número.");
            }
            if (!/[a-z]/.test(newPassword)) {
              errors.push("La contraseña debe contener al menos una letra minúscula.");
            }
            if (!/[A-Z]/.test(newPassword)) {
              errors.push("La contraseña debe contener al menos una letra mayúscula.");
            }
            if (!/[\W_]/.test(newPassword)) {
              errors.push("La contraseña debe contener al menos un carácter especial.");
            }
          
            Swal.showValidationMessage(`
              <ul style="text-align: left;">
                ${errors.map(error => `<li>${error}</li>`).join('')}
              </ul>
            `);
            return false;
          }
  
        return { currentPassword, newPassword };
      },
    }).then(async (result) => {
      if (result.isConfirmed) {

        const { currentPassword, newPassword } = result.value;
  
        Swal.fire({
          title: "Actualizando...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });
     
        try {
          const response = await updatePwdClient({ oldPwd: currentPassword, newPwd: newPassword });
          
          if (response.code === 200) {
            Swal.fire({
              icon: "success",
              title: "Contraseña actualizada",
              text: "Su contraseña ha sido actualizada exitosamente",
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          } else {
            const message = handleErrorResponse(response);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message,
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          }

        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error?.message || "Hubo un error al actualizar la contraseña",
            confirmButtonText: "Ok",
            confirmButtonColor: "#000000",
          });
        }
      }
    });

    window.togglePasswordVisibility = () => {
      const inputs = document.querySelectorAll('#current-password, #new-password, #confirm-password');

      const text = document.getElementById('toggle-password-text');

      let show = false;

      inputs.forEach(input => {
        if (input.type === "password") {
          input.type = "text";
          show = true;
        } else {
          input.type = "password";
        }
      });

      if (show) {
      
        text.textContent = "Ocultar Contraseñas";
        text.style.backgroundColor = "black";
        text.style.color = "white";
        text.style.border = "1px solid white";
      } else {
  
        text.textContent = "Mostrar Contraseñas";
        text.style.backgroundColor = "#0F4372";
        text.style.color = "white";
        text.style.border = "1px solid black";
      }
    };

      const buttons = document.querySelectorAll('.toggle-password');
      buttons.forEach(button => {
        button.style.outline = 'none';
      });

  };
  
  

  if (!user) {
    return (
      <div className="user-profile-container">
        <p>Cargando información del usuario...</p>
      </div>
    );
  }

  return (
    <div className="dashboardCard3">
      <div className="user-profile-wrapper"> 
        <div className="user-profile-container">
          <div className="user-header">
            <FaUser size={60} className="user-icon" />
            <h2>Información del Usuario</h2>
          </div>
            <div className="user-info">
              {renderUserInfo(user)}
             </div>
            <div className="update-password mt-5">
             <button className="btn-update-password" onClick={handleUpdatePassword}>
            Actualizar Contraseña
          </button>
          <p className="mt-2">Si desea actualizar su contraseña, de click aquí</p>
        
         </div>
    </div>
  </div>
</div>
 

  );
};

const renderUserInfo = (user) => {
  const userFields = [
    { label: "Nombre", value: user?.NombreSimple },
    { label: "Apellido", value: user?.ApellidoSimple },
    { label: "Email", value: user?.Email },
    { label: "Teléfono", value: user?.Telefono },
    { label: "Dirección", value: user?.Direccion },
    { label: "Caja Asignada", value: user?.NombreCaja },
    { label: "Estafeta de Usuario", value: user?.NombreEstafeta }
  ];

  return userFields
    .filter(field => field.value) 
    .map((field, index) => (
      <div key={index} className="user-field">
        <strong>{field.label}:</strong> {field.value}
      </div>
    ));
};


export default UserProfile;